import { Component, Inject } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { ModalComponent } from '../../../../shared/components/modal/modal.component';
import { ButtonComponent } from '../../../../shared/components/button/button.component';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MotoristaGerenciamentoDTO } from '../../models/motorista-gerenciamento';
import { BiometriaService } from '../../../../shared/services/biometria.service';
import { ToastService } from '../../../../shared/services/toast.service';
import { UpdateDriverBiometryDTO } from '../../models/update-driver';
import { ToastState as ts } from '../../../../shared/enums/toast-state.enum';
import { InputComponent } from '../../../../shared/components/input/input.component';
import { TegelModule } from '@scania/tegel-angular-17';
import { CpfMaskDirective } from '../../../../shared/directives/cpf-mask.directive';
import { CpfHelper } from '../../../../shared/helpers/cpf.helper';

@Component({
  selector: 'app-dialog-atualizar-motorista',
  imports: [
    ReactiveFormsModule,
    ModalComponent,
    ButtonComponent,
    InputComponent,
    TegelModule,
    CpfMaskDirective,
  ],
  templateUrl: './dialog-atualizar-motorista.component.html',
  styleUrl: './dialog-atualizar-motorista.component.scss',
})
export class DialogAtualizarMotoristaComponent {
  form: FormGroup;
  selectedFile: File | null = null;
  previewUrl: string | ArrayBuffer | null = null;

  constructor(
    private dialogRef: MatDialogRef<DialogAtualizarMotoristaComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { motorista: MotoristaGerenciamentoDTO },
    private fb: FormBuilder,
    private service: BiometriaService,
    private toast: ToastService,
  ) {
    this.form = this.fb.group({
      id: [data.motorista.biometricReferenceId],
      driverId: [
        CpfHelper.format(data.motorista.driverId),
        [Validators.required, Validators.minLength(14)],
      ],
      base64Image: [null],
    });
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.selectedFile = input.files[0];
      const reader = new FileReader();
      reader.onload = () => {
        this.previewUrl = reader.result;
        this.form.patchValue({ base64Image: reader.result as string });
      };
      reader.readAsDataURL(this.selectedFile);
    }
  }

  onSave(formData: any) {
    const cpfLimpo = CpfHelper.clean(formData.driverId);

    const dto: UpdateDriverBiometryDTO = {
      id: formData.id,
      driverId: cpfLimpo,
      base64Image: formData.base64Image,
    };

    this.service.updateRegisteredDriver(dto).subscribe({
      next: (result) => {
        if (result.success) {
          const motoristaAtualizado: MotoristaGerenciamentoDTO = {
            biometricReferenceId: formData.id,
            driverId: cpfLimpo,
            nomeMot: this.data.motorista.nomeMot,
            awsExternalId: this.data.motorista.awsExternalId,
          };

          this.toast.showToast(ts.success, 'Motorista atualizado com sucesso!');
          this.dialogRef.close(motoristaAtualizado);
        } else {
          this.toast.showToast(ts.error, result.messages[0]);
        }
      },
      error: (e) => {
        this.toast.showToast(
          ts.error,
          e.error?.messages?.[0] || 'Erro ao atualizar.',
        );
      },
    });
  }
}
